/**
 * @namespace Header
 * @aka SWR.Header
 */
SWR.Header = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'header';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '#header'
  };

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Header = function () {

    function Header(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self._halfSticky();
    }

    Header.prototype._halfSticky = function _halfSticky() {
      var self = this;

      if(!$('body').hasClass('sticky-header')) {
        var didScroll;
        var lastScrollTop = 0;
        var navbarHeight = self.$element.outerHeight();

        $(window).scroll(function(){
          didScroll = true;
        });

        setInterval(function() {
          if (didScroll) {
            hasScrolled();
            didScroll = false;
          }
        }, 250);

        function hasScrolled() {
          var scrollTop = $(this).scrollTop();

          if (scrollTop - lastScrollTop > 0 && scrollTop > navbarHeight && !self.$element.hasClass('nav-up')) {
            //Ausblenden:
            if(!$('#header-main-navi-header').hasClass('menu-open') && !$('.navbar-search').hasClass('search-open')) {
              self.$element.addClass('nav-up').removeClass('nav-down');
            }
          }else if (scrollTop - lastScrollTop < 0 && self.$element.hasClass('nav-up')) {
            //Einblenden:
            if(!$('#header-main-navi-header').hasClass('menu-open') && !$('.navbar-search').hasClass('search-open')) {
              self.$element.removeClass('nav-up').addClass('nav-down');
            }
          }

          lastScrollTop = scrollTop;
        }
      }
    };

    // public
    Header.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Header._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Header(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Header;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Header._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Header._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Header._jQueryInterface;
  $.fn[NAME].Constructor = Header;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Header._jQueryInterface;
  };

  return Header;

})(window.jQuery);
